module.exports = __webpack_public_path__ + "static/media/moving.a2d32029.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/moving.svg
// module id = 810
// module chunks = 0